export default "__VITE_ASSET__BEzmyYU4__"